import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  HomeIcon,
  UserGroupIcon,
  UserCircleIcon,
} from '@heroicons/react/24/outline';
import {
  HomeIcon as HomeIconSolid,
  UserGroupIcon as UserGroupIconSolid,
  UserCircleIcon as UserCircleIconSolid,
} from '@heroicons/react/24/solid';

const navigationItems = [
  {
    label: 'Home',
    path: '/',
    icon: HomeIcon,
    activeIcon: HomeIconSolid,
  },
  {
    label: 'Communities',
    path: '/communities',
    icon: UserGroupIcon,
    activeIcon: UserGroupIconSolid,
  },
  {
    label: 'Profile',
    path: '/profile',
    icon: UserCircleIcon,
    activeIcon: UserCircleIconSolid,
  },
];

export const MobileNav: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50">
      <div className="flex justify-around items-center h-16">
        {navigationItems.map((item) => {
          const isActive =
            location.pathname === item.path ||
            (item.path !== '/' && location.pathname.startsWith(item.path));
          const Icon = isActive ? item.activeIcon : item.icon;

          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className="flex flex-col items-center justify-center w-full h-full cursor-pointer"
            >
              <Icon
                className={`h-6 w-6 ${
                  isActive ? 'text-primary-base' : 'text-gray-500'
                }`}
              />
              <span
                className={`text-xs mt-1 ${
                  isActive ? 'text-primary-base' : 'text-gray-500'
                }`}
              >
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};